import { LIGHT_THEME } from '@signplatform-ui/colors';
import { useState } from 'react';
import type { DefaultTheme } from 'styled-components';
import gridConfig from '../gridConfig';

export default function useAppTheme(): DefaultTheme {
  const [theme] = useState(() => ({ ...LIGHT_THEME, gridConfig }));
  return theme;
}
